// action types
export const UI = "[UI]";
export const SET_LOADER = "SET_LOADER";
export const SET_SIDEBAR = `${UI} SET_SIDEBAR`;

// action creators
export const setLoader = ({ state, resource }) => ({
  type: `${resource} ${SET_LOADER}`,
  payload: state,
  meta: { resource }
});

export const setSidebar = ({ state }) => ({
  type: SET_SIDEBAR,
  payload: state
});



// WEBPACK FOOTER //
// ./src/redux/actions/uiActions.js